<template>
  <input type="text"
    v-number-only
    v-model="model"
    @focus="$emit('focus')"
    @keypress="eventKeyPress"/>
</template>

<script>
  import BigNumber from 'bignumber.js';
  export default {
    data() {
      return {
        model: "",
        originValue: ''
      }
    },
    props: {
      value: '',
      precision: {
        type: Number,
        default: 9,
      },
    },
    watch: {
      value() {
        this.init();
        this.change();
      },
      model(newValue) {
        this.$emit('input', newValue);
        this.emitDirtyIfNeed();
      }
    },
    methods: {
      eventKeyPress(event) {
        const input = event.target;
        const charCode = (event.which) ? event.which : event.keyCode;
        const ch = String.fromCharCode(charCode);

        // allow only digits and dot on keypress
        if (!/[0-9.]/.test(ch)) {
          if (charCode > 31 && charCode !== 46) {
            event.preventDefault();
          }
          return true;
        }

        let stringValue = "" + (this.model == null ? '' : this.model);
        const start = input.selectionStart != null ? input.selectionStart : stringValue.length;
        const end = input.selectionEnd != null ? input.selectionEnd : stringValue.length;
        const next = stringValue.slice(0, start) + ch + stringValue.slice(end);

        if (ch === '.' && stringValue.indexOf('.') !== -1) {
          event.preventDefault();
          return true;
        }

        if (next.length > 16) {
          event.preventDefault();
          return true;
        }

        const parts = next.split('.');
        if (parts.length > 2) {
          event.preventDefault();
          return true;
        }
        if (parts[1] && parts[1].length > this.precision) {
          event.preventDefault();
          return true;
        }

        return true;
      },

      init() {
        if (!this.value) {
          this.model = "";
          return;
        }
        this.model = this.value;
      },
      change() {
        if (!this.value) {
          this.model = "";
          return;
        }

        let precision = this.precision;
        if (precision) {
          let currentValue = this.value + '';
          let vals = currentValue.split('.');

          let valPrecision = vals[1];
          if (valPrecision != undefined) {
            let valLength = valPrecision.length;
            if (valLength > 0) {
              if (valLength < (parseInt(precision))) {
                return true;
              }

              this.model = this.newBigNumber(this.value).toFixed(precision);
              return true;
            }
          }

        }

        this.model = this.value;
      },


      emitDirtyIfNeed() {
        const a = parseFloat(this.originValue);
        const b = parseFloat(this.model);
        if (a !== b) {
          this.$emit('dirty', true);
        }
      },

      newBigNumber(value) {
        if (window._.isEmpty(value)) {
          value = 0;
        }
        return new BigNumber(value);
      }

    },
    directives: {
      "number-only": {
        bind(el, binding) {
          el.value = insertNumber(el.value);
          binding.value = el.value;
        },

        inserted(el, bind) {
          el.value = insertNumber(el.value);
          bind.value = el.value;
        },

        update(el, bind) {
          el.value = insertNumber(el.value);
          bind.value = el.value;
        },
      }
    },

    mounted() {
      this.init();
      this.originValue = window._.cloneDeep(this.model);
    }
  }

  function insertNumber(newValue) {
    // allow digits and a single '.', cap total length to 16, fractional to 9
    let s = "" + (newValue == null ? "" : newValue);

    // remove invalid chars
    s = s.replace(/[^0-9.]/g, '');

    // keep only first dot
    const firstDot = s.indexOf('.');
    if (firstDot !== -1) {
      s = s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, '');
      const parts = s.split('.');
      const PREC = 9;
      parts[1] = (parts[1] || '').slice(0, PREC); // limit fractional digits to 9
      s = parts[0] + (parts[1] !== undefined ? '.' + parts[1] : '');
    }

    // cap to 16 total characters (including dot)
    if (s.length > 16) s = s.slice(0, 16);

    return s;
  }
</script>

<style scoped>

</style>